import type { NodeProps } from '@gitbook/slate-react';

export const dragDropPlugin = {
    shouldNodeComponentUpdate,
};

/**
 * Used to determine if a Block need to be updated/rerender after a drag and drop happened.
 * Only update if the Block changed position and the previous or new position is the last child of the parent.
 */
function shouldNodeComponentUpdate(props: NodeProps, nextProps: NodeProps): boolean | null {
    // If the position of the node has changed(eg: drag and drop) and it was or became the last child of the list, update.
    const parentSize = props.parent.nodes.size - 1;
    const previousIndex = props.parent.getChildIndex(props.node.key);
    const newIndex = nextProps.parent.getChildIndex(props.node.key);
    if ((previousIndex === parentSize || newIndex === parentSize) && newIndex !== previousIndex) {
        return true;
    }

    return null;
}
